import SegmentAnalytics from '../../components/analytics/SegmentAnalytics';

export const fsEvents = {
	videoLoad: 'OnLoadReleaseUrl',
	videoBuffer: 'OnMediaBuffer',
	videoEnd: 'OnMediaComplete',
	videoChapterEnd: 'OnMediaEnd',
	videoError: 'OnMediaError',
	videoLoading: 'OnMediaLoadStart',
	videoReady: 'OnLoadRelease',
	videoPause: 'OnMediaPause',
	videoPlay: 'OnMediaPlay',
	videoProgress: 'OnMediaPlaying',
	videoSeek: 'OnMediaSeek',
	videoStart: 'OnMediaStart',
	videoResume: 'OnMediaUnpause',
    videoMute: 'OnMute',
	playerReady: 'OnPlayerLoaded',
    playerOverlayUp: 'OnShowPlayOverlay',
    playbackStart: 'OnPlaybackStart',
    playbackComplete: 'OnPlaybackComplete',
    contentStart: 'OnContentStart',
    contentComplete: 'OnContentComplete',
    contentPlaying: 'OnContentPlaying'
};

class FsVideoEventHandler {
    constructor() {
        this.events = {};
    }

    dispatchEvent(eventName, data) {
        if(!this.events.hasOwnProperty(eventName)) return;
        SegmentAnalytics.trackVideoEvent(eventName, data);
        this.events[eventName].callbacks.forEach(cb => {
            cb(data);
        });
    }

    addEventListener(eventName, callback) {
        if(!this.events.hasOwnProperty(eventName)) {
            this.events[eventName] = {
                callbacks: []
            }
        }
        this.events[eventName].callbacks.push(callback);
    }

    removeEventListener(eventName, callback) {
        if(this.events.hasOwnProperty(eventName)) {
            let index = this.events[eventName].indexOf(callback);

            if (index > -1) {
                this.events[eventName].splice(index, 1);
			}
        }
    
    }
    
    onVideoStart( callback ) {
        this.addEventListener(fsEvents.videoStart, callback);
    }

	onVideoPause(callback) {
    	this.addEventListener(fsEvents.videoPause, callback);
	}

	onVideoEnd(callback) {
		this.addEventListener(fsEvents.videoEnd, callback);
    }
    
    onPlayerLoaded(callback) {
        this.addEventListener(fsEvents.playerReady, callback);
    }

    onVideoProgress(callback) {
        this.addEventListener(fsEvents.videoProgress, callback);
    }

    //segment analytics related events
    onPlaybackStart(callback) {
        this.addEventListener(fsEvents.playbackStart, callback);
    }
    onPlaybackComplete(callback) {
        this.addEventListener(fsEvents.playbackComplete, callback);
    }
    onContentStart(callback) {
        this.addEventListener(fsEvents.contentStart, callback);
    }
    onContentComplete(callback) {
        this.addEventListener(fsEvents.contentComplete, callback);
    }
    onContentPlaying(callback) {
        this.addEventListener(fsEvents.contentPlaying, callback);
    }
}

let fsVideoEventHandler = new FsVideoEventHandler();
window.FsVideoEventHandler = fsVideoEventHandler;
export default fsVideoEventHandler;



// WEBPACK FOOTER //
// ./assets/components/platformPlayer/FsVideoEventHandler.js